import store from './store';
import { ActionCreators, ActionTypes } from './store/actions';
import * as EventTypes from './store/events';
import Modal from './modules/Modal';
import Backdrop from './modules/Backdrop';
import Popover from './modules/Popover';
import Slider from './modules/Slider';
import captcha from './modules/captcha';
import * as inject from './utils/inject';

const app = {
	store,
	ActionTypes,
	ActionCreators,
	EventTypes,
	Modal,
	Backdrop,
	Popover,
	Slider,
	captcha,
	inject
};

if (window.__app__)
	Object.assign(window.__app__, app);
else
	window.__app__ = app;